import { gql } from '@apollo/client';
export const stakingFragment = gql `
  fragment stakingFields on StakingEntity {
    id
    principalAmount
    interestRate
    duration
    accrualInterval
    harvestMode
    autoInvest
    activatedAt
    createdAt
    status
    lastRedeemedAt
    autoSubscription
    redeemableRewards
    earlyRedemptionFeeRate
  }
`;
export const extendedStakingFragment = gql `
  fragment stakingExtendedFields on GetExtendedStakingPayload {
    id
    autoInvest
    lastRedeemedAt
    activatedAt
    autoSubscription
    principalAmount
    redeemableRewards
    earlyRedemptionFeeRate
    duration
    createdAt
    status
    interestRate
    accrualInterval
    harvestMode
    expiresAt
    nextAccrualDate
    nextAccrualAmount
    totalPercentage
    totalRewards
    lastAccrualDate
  }
`;
//# sourceMappingURL=staking.js.map